import React, { Component } from 'react';
import CustomSelect from './CustomSelect';
import UserAPI from "restAPI/UserAPI";

export default class SelectWithUserEmail extends Component {
  static defaultProps = {
    api: UserAPI.getAll,
    labelKey: 'email',
    valueKey: 'email',
    mode: "tags"
  }

  generateSelectOptions = (options) => {
    const { labelKey, valueKey, parseSelectOptions } = this.props;
    const tempOptions = options.map(option => ({label: option[labelKey], value: option[valueKey]}));
    if (parseSelectOptions) {
      parseSelectOptions(options);
    }
    return tempOptions;
  }

  render () {
    const { props, generateSelectOptions } = this;
    const { labelKey, valueKey, ...restProps } = props;
    return (
      <CustomSelect
          {...restProps}
          allowClear
          style={{ width: '100%' }}
          parseSelectOptions={generateSelectOptions}
      />
    )
  }
}